module.exports = __webpack_public_path__ + "static/media/head.ed6c59d7.png";